import classes from "./ProgressBar.module.css";
import translations from "../../en.json";
import translationsNo from "../../no.json";
import { useSelector } from "react-redux";

export function ProgressBar({ width }) {
  const { language } = useSelector((state) => state.global);

  const text = language === "en" ? translations : translationsNo;

  function outputText(width) {
    if (width === 0) {
      return text.progressBarText.text0;
    }
    const ranges = [
      { max: 10, min: 1, key: "text10" },
      { max: 20, min: 10, key: "text20" },
      { max: 36, min: 20, key: "text30" },
      { max: 45, min: 36, key: "text40" },
      { max: 60, min: 51, key: "text60" },
      { max: 70, min: 60, key: "text70" },
      { max: 87, min: 70, key: "text80" },
      { max: 99, min: 87, key: "text90" },
    ];
    if (width === 50) {
      return text.progressBarText.text50.replace("{width}", width);
    }
    if (width === 100) {
      return text.progressBarText.text100.replace("{width}", width);
    }
    for (const range of ranges) {
      if (width < range.max && width > range.min) {
        return text.progressBarText[range.key].replace("{width}", width);
      }
    }
  }

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <p dangerouslySetInnerHTML={{ __html: outputText(width) }}></p>
        <div className={classes.grayBar}></div>
        <div className={classes.bar} style={{ width: `${width}%` }}></div>
      </div>
    </div>
  );
}
